var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-panel-header"},[_c('ul',{staticClass:"tabs-rec",attrs:{"id":"home-tab-menu"}},_vm._l((_vm.tablist),function(tab){return _c('li',{key:tab.id,class:{ active: tab.selected },on:{"click":function($event){return _vm.selectTab(tab.name)}}},[_c('span',{class:tab.icon}),_vm._v(" "+_vm._s(tab.title))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }